import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HypermatrixCatalogsService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.hypermatrix_url;
  }

  //
  getCatalog=(catalogType:string)=> {
    return this.http.get(`${this.url}/job/retrieveCatalogType/${catalogType}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getDependenciasAfiliadoHM=()=> {
    return this.http.get(`${this.url}/CatAfiliateHM/getAllCatAfiliateHM`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
